import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Account } from '@/domain/accounts/account'
import { ArrowRightCircle, CreditCard } from 'lucide-react'

interface AccountStatusCardProps {
  contractAccount: Account
  onViewMovements: () => void
}

export const AccountStatusCard = ({ contractAccount, onViewMovements }: AccountStatusCardProps) => {
  return (
    <Card className="border-primary/20 bg-primary/5">
      <CardHeader className="pb-3 text-primary">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <CreditCard className="h-5 w-5" />
            <CardTitle className="text-lg">Estado de Cuenta</CardTitle>
          </div>
          <Badge variant={contractAccount.currentBalance >= 0 ? 'success' : 'destructive'} className="text-tiny font-bold">
            {contractAccount.currentBalance >= 0 ? 'AL DÍA' : 'CON DEUDA'}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-col gap-1">
          <span className="text-sm font-medium text-muted-foreground">Saldo del Contrato</span>
          <div className="flex items-center gap-2">
            <span className={`${contractAccount.currentBalance >= 0 ? 'text-green-600' : 'text-red-600'} text-3xl font-bold tracking-tight`}>
              ${contractAccount.currentBalance.toLocaleString('es-AR')}
            </span>
          </div>
          <p className="text-tiny font-mono text-muted-foreground mt-1 uppercase tracking-wider">
            CTA: {contractAccount.accountNumber}
          </p>
        </div>
        <Button
          variant="outline"
          size="sm"
          className="w-full bg-background"
          onClick={onViewMovements}
        >
          Ver Movimientos
          <ArrowRightCircle className="ml-2 h-4 w-4" />
        </Button>
      </CardContent>
    </Card>
  )
}
